import React from 'react';
import { Button, Typography } from 'antd';
type bodyCard = {
  title: string;
  subtitle: string;
  data?: number | string;
  icon: string;
  onButton?: () => void;
  btnTitle?: string;
  isShowBtn?: boolean;
  style?: any;
  check?: number;
};
const { Text } = Typography;
const CardBody: React.FC<bodyCard> = ({
  title,
  subtitle,
  data,
  isShowBtn,
  icon,
  onButton,
  btnTitle,
  check
}) => {
  return (
    <div className={'home_body_card'}
      style={{
        borderTopLeftRadius: check === 1 ? '10px' : '0px',
        borderBottomLeftRadius: check === 1 ? '10px' : '0px',
        borderBottomRightRadius: check === 2 ? '10px' : '0px',
        borderTopRightRadius: check === 2 ? '10px' : '0px'
      }}
    >
      <div>
        <h4 style={{ fontWeight: 'bold', color: '#000000', fontSize: '16px' }}>
          {title}
        </h4>
        <Text style={{ color: '#9C9C9C ', fontSize: '12px' }}>{subtitle}</Text>
      </div>
      <div style={{ marginTop: '50px' }} className={'home_body_card_content'}>
        <h1>{data}</h1>
        <span style={{ marginTop: '42px' }}>
          <img src={icon} alt={'icon'} width={123} height={123} />
        </span>
        <br />
        {isShowBtn && (
          <Button
            onClick={onButton}
            style={{
              marginTop: '70px',
              height: '40px',
              width: '60%',
              background: ' #4786E4',
              borderRadius: '20px ',
              color: 'white',
              fontSize: '16px',
            }}
          >
            {btnTitle}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CardBody;
